<div class="dialog-title">Switch Project</div>
<mat-card class="core-list scrollable">
  <mat-list>
    <ng-container *ngFor="let project of projects">
      <mat-list-item
        *ngIf="project.id != currentProject.id"
        (click)="switchProject(project?.id)"
      >
        <mat-icon> chevron_right </mat-icon>
        <div class="xsTitle-f" matLine>{{project.name}}</div>
        <!-- <div matLine class="xsDesc-f">
          {{project.city.name}}, {{project.state.name}}
        </div> -->
        <div matLine class="xsDesc-f">{{project.city}}, {{project.state}}</div>

        <mat-divider></mat-divider>
      </mat-list-item>
    </ng-container>
  </mat-list>
</mat-card>
